import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import "./Home.css";

function CreateFormModal({ show, onClose, onFormCreated }) {
  const [formName, setFormName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyImage, setCompanyImage] = useState(null);
  const [companyImageUrl, setCompanyImageUrl] = useState("");
  const [policyText, setPolicyText] = useState(""); // New State
  const [policyLink, setPolicyLink] = useState(""); // New State

  if (!show) return null;

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setCompanyImage(file);

    const formData = new FormData();
    formData.append("image", file);

    try {
      const token = localStorage.getItem("token");
      const res = await fetch("https://leadbankapi.gensparc.com/api/upload", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });
      const data = await res.json();
      setCompanyImageUrl(data.imageUrl);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formName.trim() || !companyName.trim()) {
      alert("Please enter both form name and company name.");
      return;
    }

    const newFormId = uuidv4();

    try {
      const token = localStorage.getItem("token");
      const res = await fetch("https://leadbankapi.gensparc.com/api/forms/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id: newFormId,
          name: formName,
          company_name: companyName,
          company_image: companyImageUrl,
          policy_text: policyText, // Sending policy text
          policy_link: policyLink, // Sending policy link
        }),
      });

      const data = await res.json();
      if (res.ok) {
        onFormCreated({
          id: data.formId,
          name: formName,
          company_name: companyName,
          company_image: companyImageUrl,
          policy_text: policyText,
          policy_link: policyLink,
        });

        setFormName("");
        setCompanyName("");
        setCompanyImage(null);
        setCompanyImageUrl("");
        setPolicyText("");
        setPolicyLink("");

        onClose();
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("Error creating form:", error);
    }
  };

  return (
    <div className="modal-overlay" id="create-form-modal">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Create New Form</h2>
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Form Name:</label>
              <input
                type="text"
                placeholder="Enter form name"
                value={formName}
                onChange={(e) => setFormName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Company Name:</label>
              <input
                type="text"
                placeholder="Enter company name"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Company Image:</label>
              <input type="file" accept="image/*" onChange={handleImageUpload} />
              {companyImageUrl && (
                <img
                  src={`https://leadbankapi.gensparc.com${companyImageUrl}`}
                  alt="Company Preview"
                  className="uploaded-preview"
                />
              )}
            </div>

            {/* Policy Text Field */}
            <div className="form-group">
              <label>Policy Text:</label>
              <textarea
                placeholder="Enter policy details..."
                value={policyText}
                onChange={(e) => setPolicyText(e.target.value)}
                required
              ></textarea>
            </div>

            {/* Policy Link Field */}
            <div className="form-group">
              <label>Policy Link:</label>
              <input
                type="url"
                placeholder="Enter policy page link"
                value={policyLink}
                onChange={(e) => setPolicyLink(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn submit">
              Create Form
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateFormModal;
